import { OrderStatus } from '../__generated-gql-types__/globalTypes';

import { OrderType } from './types';

interface BasicOrder {
  hourlyOrder?: Possible<unknown>;
  packageOrder?: Possible<unknown>;
  classOrder?: Possible<unknown>;
  bootcampOrder?: Possible<unknown>;
  subscriptionOrder?: Possible<unknown>;
}

export const getOrderType = (
  order: BasicOrder,
  defaultType?: OrderType,
): OrderType => {
  if (order.hourlyOrder != null) {
    return OrderType.HOURLY;
  } else if (order.packageOrder != null) {
    return OrderType.PACKAGE;
  } else if (order.classOrder != null) {
    return OrderType.CLASS;
  } else if (order.bootcampOrder != null) {
    return OrderType.BOOTCAMP;
  } else if (order.subscriptionOrder != null) {
    return OrderType.SUBSCRIPTION;
  } else if (defaultType) {
    return defaultType;
  } else {
    throw new Error('Could not extract order type');
  }
};

const ACCEPTABLE_CHECKOUT_ORDER_STATUSES = [
  OrderStatus.CREATED,
  OrderStatus.INVOICING,
];

export const isOrderStatusEligibleForCheckout = (orderStatus: OrderStatus) => {
  return ACCEPTABLE_CHECKOUT_ORDER_STATUSES.includes(orderStatus);
};

export const calculateHourlyTotal = (
  minutes: number,
  hourlyRate: number,
): number => {
  if (minutes > 0 && hourlyRate != null) {
    return hourlyRate * (minutes / 60);
  }

  return 0;
};

export const DEFAULT_HOURLY_ORDER_MINUTES = 4 * 60;
